import * as tslib_1 from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, defaultPath } from "./graphqueryable";
import { jsS } from "@pnp/common";
var Members = /** @class */ (function (_super) {
    tslib_1.__extends(Members, _super);
    function Members() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Members_1 = Members;
    /**
     * Use this API to add a member to an Office 365 group, a security group or a mail-enabled security group through
     * the members navigation property. You can add users or other groups.
     * Important: You can add only users to Office 365 groups.
     *
     * @param id Full @odata.id of the directoryObject, user, or group object you want to add (ex: https://graph.microsoft.com/v1.0/directoryObjects/${id})
     */
    Members.prototype.add = function (id) {
        return this.clone(Members_1, "$ref").postCore({
            body: jsS({
                "@odata.id": id,
            }),
        });
    };
    /**
     * Gets a member of the group by id
     *
     * @param id Group member's id
     */
    Members.prototype.getById = function (id) {
        return new Member(this, id);
    };
    var Members_1;
    Members = Members_1 = tslib_1.__decorate([
        defaultPath("members")
    ], Members);
    return Members;
}(GraphQueryableCollection));
export { Members };
var Member = /** @class */ (function (_super) {
    tslib_1.__extends(Member, _super);
    function Member() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Removes this Member
     */
    Member.prototype.remove = function () {
        return this.clone(Member, "$ref").deleteCore();
    };
    return Member;
}(GraphQueryableInstance));
export { Member };
var Owners = /** @class */ (function (_super) {
    tslib_1.__extends(Owners, _super);
    function Owners() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Owners = tslib_1.__decorate([
        defaultPath("owners")
    ], Owners);
    return Owners;
}(Members));
export { Owners };
//# sourceMappingURL=members.js.map